import 'babel-polyfill';
import React, { PropTypes } from 'react';
// import { compose } from 'redux';
// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level.
class App extends React.Component {
  render() {
    return this.props.children;
  }
}

App.propTypes = {
  children: PropTypes.element
};

export default App;



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/